import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Router, ActivatedRoute } from '@angular/router';
import { gsap } from "gsap/all";
import { CmsPlanComercialService } from '../../../services/cms/cms.plan.comercial.service';
import { PaquetesPlancomercial } from 'src/app/models/cms/cms.plan.comercial.model';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { faTimes, faArrowRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { GtmService } from 'ngx-gtm';
import { DynamicHelper } from 'src/app/helpers/dynamic-helper';

@Component({
  selector: 'app-paquetes',
  templateUrl: './paquetes.component.html',
  styleUrls: ['./paquetes.component.scss']
})
export class PaquetesComponent implements OnInit {

  title: string = 'Paquetes';

  faTimes = faTimes;
  faArrowRight = faArrowRight;
  faChevronDown = faChevronDown;

  bannerImage: string;
  bannerImageMobile: string;
  bannerTitle: string;
  paquetes: PaquetesPlancomercial[];
 
  baseCMSUrl: string;
  webUrl: string;

  /*Loaders*/
  isBannerLoaded: boolean;
  isProductosLoaded: boolean;
  isPaquetesLoaded: boolean;

  constructor(
    public router: Router,
    private cmsPlanComercialService: CmsPlanComercialService,
    private authService: AuthService,
    private configuration: ConfigurationService,
    private gtm: GtmService,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService
  ) {
    this.isBannerLoaded = false;
    this.isProductosLoaded = false;
    this.isPaquetesLoaded = false;

    this.baseCMSUrl = this.configuration.baseCmsUrl;
    this.webUrl = this.configuration.webUrl;

    if (this.authService.isLoggedIn) {
      this.getDataFromServices();
    } else {
      this.authService.loginByApp().subscribe(resp => {//console.log('Resp login:',resp)
        this.getDataFromServices();
      });
    }
  }

  ngOnInit(): void {
    this.gtm.push({ event: 'TelevisaLlega Paquetes' });

    this.seoService.update({
      title: this.title,
      description: 'Conoce las soluciones integrales de comunicación que ofrece Televisa, sus múltiples puntos de contacto y la efectividad publicitaria de sus plataformas.',
      keywords: 'Plan comercial Televisa, Plan comercial, publicidad en Televisa, mensajes publicitarios, estrategia publicitaria, publicidad, efectividad publicitaria, puntos de contacto Televisa, fortalezas Televisa',
    });
  }

  getDataFromServices() {

    this.getPaquetes();
    this.getBannerImage();

  }

  public getPaquetes() {
    this.cmsPlanComercialService.getPaquetes().subscribe(response => {
      this.paquetes = response.data.paquetesPlancomercial.map((v: PaquetesPlancomercial) => {
        v.linkTarjeta = `/paquetes/paquete/${v.displayText}`;
        this.isPaquetesLoaded = true;
        this.cdr.markForCheck();
        return v;
      });
      this.paquetes.sort(this.ordenaArregloPropiedadOrden);
    });
  }

  ordenaArregloPropiedadOrden(obj1, obj2) {
    if (obj1.orden > obj2.orden) { return 1; }
    if (obj1.orden < obj2.orden) { return -1; }
    return 0;
  }

  public getBannerImage() {
    this.cmsPlanComercialService.getBannerHero().subscribe(response => {
      for (let i = 0; i < response.data.bannersdePaquetes.length; i++) {
        if (response.data.bannersdePaquetes[i].displayText === 'Paquetes') {
          this.bannerImage = this.baseCMSUrl.slice(0, -1) + response.data.bannersdePaquetes[i].bannerImage.urls[0];
          this.bannerImageMobile = this.baseCMSUrl.slice(0, -1) + response.data.bannersdePaquetes[i].imagenMobile.urls[0];
          this.bannerTitle = response.data.bannersdePaquetes[i].bannerTitle;
          this.isBannerLoaded = true;
          this.cdr.markForCheck();
        }
      }
    });
  }

  public navigateTo(path: string): void {
    this.router.navigateByUrl(path);
    gsap.to(window, {
      scrollTo: 0,
      duration: 0.5
    });
  }

  public dynamicId(objeto: string, nombre: string) {
    return DynamicHelper.dynamicIdHelper(objeto, nombre);
  }

}
